import ApiClient from './ApiClient';
/* global axios */

// Aviso obligatorio "Un solo equipo" (Victor 2026-06-07).
class AnnouncementAPI extends ApiClient {
  constructor() {
    super('announcement', { accountScoped: true });
  }

  // ¿Debe salirle el modal al agente hoy? { pending, vigencia_end, active }
  status() {
    return axios.get(`${this.url}/status`);
  }

  // Registra el "Confirmado" del agente para el día actual.
  confirm() {
    return axios.post(`${this.url}/confirm`);
  }

  // Contador + desglose por sucursal (solo super_admin).
  stats() {
    return axios.get(`${this.url}/stats`);
  }
}

export default new AnnouncementAPI();
